// extracted by mini-css-extract-plugin
export var checkbox = "Checkbox-module--checkbox--f5a37";
export var content = "Checkbox-module--content--c7171";
export var fadeInAnimation = "Checkbox-module--fadeInAnimation--6b462";
export var hint = "Checkbox-module--hint--045e7";
export var input = "Checkbox-module--input--ac454";
export var mark = "Checkbox-module--mark--715f4";